const base = process.env.REACT_APP_BASE_URL;

const endpoints = {
    auth: {
        getUniqueData: (uuid) => base + 'get-meeting/' + uuid,
    },
};

export { endpoints };
